import { getPaginated } from '@/api/implementation/app/wrapper.js';

function autocomplete(page, perPage, search, sortBy, descending, params) {
  return getPaginated('product-type', page, perPage, search, sortBy, descending, params);
}

export {
  autocomplete,
}
